import { v4 as uuidv4 } from "uuid";
import { createImageBlock } from "@/react/components/shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH4Block,
  createPBlock,
} from "@/react/components/shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { defaultData as defaultH4Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H4Block/H4BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const featureListContentDescriptionTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createH4Block({
      text: "Short heading here",
      baseData: defaultH4Data,
      styles: {
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createPBlock({
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
      baseData: defaultPData,
      styles: {
        color: getColorOptions(defaultStyles.color),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
  ],
};

const featureListContentImageTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createImageBlock({
      signedId: "",
      placeholder: placeholderImage,
      baseData: defaultImageData,
      styles: {
        sizing: getSizingOptions({
          defaultValue: {
            width: "48px",
            height: "48px",
            minWidth: "auto",
            minHeight: "auto",
            maxWidth: "auto",
            maxHeight: "auto",
          },
        }),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: {
            border_left_top_radius: "100%",
            border_left_bottom_radius: "100%",
            border_right_top_radius: "100%",
            border_right_bottom_radius: "100%",
          },
        }),
      },
    }),
  ],
};

const imageSectionTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createImageBlock({
      signedId: "",
      placeholder: placeholderImage,
      baseData: defaultImageData,
      styles: {
        sizing: getSizingOptions({
          defaultValue: {
            width: "100%",
            height: "384px",
            minWidth: "100px",
            minHeight: "100px",
            maxWidth: "100%",
            maxHeight: "auto",
          },
        }),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: {
            border_left_top_radius: 20,
            border_left_bottom_radius: 20,
            border_right_top_radius: 20,
            border_right_bottom_radius: 20,
          },
        }),
      },
    }),
  ],
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureBlock4",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [],
    },
    featureListContentDescription1: featureListContentDescriptionTemplate,
    featureListContentDescription2: featureListContentDescriptionTemplate,
    featureListContentDescription3: featureListContentDescriptionTemplate,
    featureListContentImage1: featureListContentImageTemplate,
    featureListContentImage2: featureListContentImageTemplate,
    featureListContentImage3: featureListContentImageTemplate,
    imageSectionContent: imageSectionTemplate,
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
